<template>
    <div class="home">
        <div class="icon" @click="show=true">
            <img src="@/assets/imgs/icon.png"  alt="" class="one">
            <img src="@/assets/imgs/icontext.png" alt="" class="two">
            <span>不/忘/初/心/牢/记/使/命</span>
{{msg}}
        </div>
        <router-link to="/home">
            <div class="enter" >进入系统</div>
        </router-link>
      <el-dialog
          title="提示"
          :visible.sync="show"
          width="30%"
           >
        <el-input type="text" v-model="domain" placeholder="请输入域名" />
        <span slot="footer" class="dialog-footer">
    <el-button @click="show = false">取 消</el-button>
    <el-button type="primary" @click="confirmDomain">确 定</el-button>
  </span>
      </el-dialog>
    </div>
</template>
<script>
    import {save_visit,get_visit} from '@/api/module/api'
    export default {
        data(){
            return {
                msg:'',
              show:false,
              domain:localStorage.getItem('domain')||'http://bndj.laimokj.com'
            }
        },
        created() {
            this.savePage();
            // this.getPage()
        },
        methods:{
          confirmDomain(){
            localStorage.setItem('domain',this.domain);
            this.show=false;
          },
            async savePage(){
                const {data}=await save_visit({
                    type:1
                })

            },
            async getPage(){
                await get_visit()
            }
        }
    }
</script>
<style scoped>

    .home {
        background: url(../assets/imgs/cover.png);
        background-size: 100% 100%;
        width: 100%;
        height: 100vh;
    }

    .home .icon {
        padding-top: 5.5vw;
        padding-left: 8.8vw;
        display: flex;
        align-items: flex-end;
    }

    .home .icon span {
        font-size: 2.5vw;
        color: #DB3127;
        letter-spacing: 10px;
        line-height: 4vw;
        margin-left: 1vw;
    }

    .home .icon .one {
        width: 10vw;
    }

    .home .icon .two {
        width: 35.4vw;
    }

    .home .enter {
        width: 23.4vw;
        background: #DB3127;
        color: white;
        border-radius: 10vw;
        font-size: 2.8vw;
        font-weight: bold;
        height: 6vw;
        line-height: 5.8vw;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: MicrosoftYaHei-Bold;
        box-shadow: 0 0 20px rgba(145, 21, 14, 0.4), 0 -4px 5px 4px rgba(176, 29, 22, 0.7) inset, 0 4px 5px 4px rgba(235, 141, 135, 0.7) inset;
        border: 0.7vw solid #FACB6C;
        position: fixed;
        top: 40.2%;
        left: 21.5%;
    }
</style>
